import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    root: {
        height: 40,
        width: 218
    }
}));

export default useStyles;